<template>
  <cec-select-search
    v-model="internalValue"
    :options="options"
    :state="state"
    :disabled="disabled || loading"
    :placeholder="placeholder"
    v-bind="$attrs"
  />
</template>

<script>
import CecSelectSearch from './CecSelectSearch.vue';

export default {
  name: 'TabelaPrecoDropDown',
  components: { CecSelectSearch },
  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Pesquise pela tabela de preço...'
    },
  },

  data: function () {
    return {
      internalValue: this.value,
      options: [],
      loading: false
    };
  },

  watch: {
    value(newVal) {
      this.internalValue = newVal;
    },
    internalValue(newVal) {
      this.$emit('input', newVal);
    }
  },

  async mounted() {
    await this.carregarOpcoes();
  },

  methods: {
    async carregarOpcoes() {
      this.loading = true;
      try {
        const { data } = await this.$http.get('/api/protected/tabelapreco/getAtivos');
        
        this.options = data.map(item => ({
          value: item.ID,
          text: `${item.ID} - ${item.DESCRICAO}`
        }));
      } catch (err) {
        console.error('Erro ao carregar tabelas de preço:', err);
        this.options = [];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/componentes/dropdown/TabelaPrecoDropDown.vue